<template>
	<div class="container" v-show="showpage">
		<!--头部-开始-->
		<div class="header">
			<div class="pub_div hd_box">
				<div class="logo"><a href="javascript:void(0)"></a></div>
				<div class="menu">
					<ul>
						<li><a href="javascript:void(0)" @click.prevent="menuHandle('about')">公司介绍</a></li>
						<li><a href="javascript:void(0)" @click.prevent="menuHandle('business')">主营业务</a></li>
						<li><a href="javascript:void(0)" @click.prevent="menuHandle('certificate')">荣誉资质</a></li>
						<li><a href="javascript:void(0)" @click.prevent="menuHandle('contact')">联系我们</a></li>
					</ul>
				</div>
			</div>
		</div>
		<!--头部-结束-->
		
		<div class="block_box" id="section_about"></div>
		
		<!--企业介绍-开始-->
		<div class="about_box">
			<div class="pub_div about_content">
				<h1>公司介绍</h1>
				<div class="profile">
					<p>公司成立于2004年，深耕医疗行业二十余年，专注医院和科室音视频系统建设、手术转播及医疗会议服务。依托先进音视频与传输技术，实现手术与课件高清录制、呈现；实现院内手术室与会议室互联互通，院外通过互联网互动交流。</p>
					<p>2026年推出视翰医学点播平台，涵盖消化内镜、呼吸内镜两个领域，为医学从业人员提供高效便捷的视频点播服务。未来公司将持续创新，以数字化技术赋能医疗场景，助力临床医师释放专业价值。</p>
					<p><b>消化内镜点播平台</b>：包含长海消化内镜空中大讲堂、东方消化内镜学术大会（OCGE)、长海消化病和消化内镜周(CHDDW)、科主任培训班等栏目。</p>
					<p><b>呼吸内镜点播平台</b>：包含长海呼吸介入沙龙、呼吸内镜培训学院、上海呼吸病专题会议等栏目。</p>
					<div class="btns">
						<a href="https://xh.shshtec.com" target="_blank">消化内镜点播平台</a>
						<a href="https://hx.shshtec.com" target="_blank">呼吸内镜点播平台</a>
					</div>
				</div>
			</div>
		</div>
		<!--企业介绍-结束-->
		
		<div class="block_box" id="section_business"></div>
		
		<!--主营业务-开始-->
		<div class="business_box">
			<div class="pub_div business">
				<h1>主营业务</h1>
				<div class="main_tab_box">
					<ul>
						<li v-for="(item, index) in businessList" :key="index" :class="business==index ? 'selected':''" @click="businessHandle(index)">{{item}}</li>
					</ul>
				</div>
				<div class="main_content_box">
					
					<!--示教系统-开始-->
					<template v-if="business ==0">
					<h2>实现诊疗室至会议室音视频一体化，采用广播级非压缩传输技术，支持多路实时录制、示教、传输及与线上专家互动交流。</h2>
					<div class="content_box">
						<div class="left_menu">
							<ul>
								<li v-for="(item, index) in shijiaoList" :key="index" :class="shijiao == index ? 'selected':''" @click="shijiaoHandle(index)">{{item}}</li>
							</ul>
						</div>
						<div class="picture_box">
							<div class="picture" v-for="(item, index) in shijiaoPictureList" :key="index">
								<div class="title">{{item.Title}}</div>
								<img :src="item.Picture">
							</div>
						</div>
					</div>
					</template>
					<!--示教系统-开始-->
					
					<!--视频直播点播系统-开始-->
					<template v-if="business ==1">
					<h2>专注医疗全场景直播，让每一台手术、每一场学术会议都能高清实时触达；医学视频点播平台给广大用户提供了便捷的观看服务。</h2>
					<div class="content_box">
						<div class="left_menu">
							<ul>
								<li v-for="(item, index) in videoList" :key="index" :class="video == index ? 'selected':''" @click="videoHandle(index)">{{item}}</li>
							</ul>
						</div>
						<div class="picture_box">
							<div class="picture" v-for="(item, index) in videoPictureList" :key="index">
								<div class="title">{{item.Title}}</div>
								<img :src="item.Picture">
							</div>
						</div>
					</div>
					</template>
					<!--视频直播点播系统-开始-->
					
					<!--医学会议服务-开始-->
					<template v-if="business ==2">
					<h2>提供会议设备租赁与搭建、会议网站搭建、精品课程制作，及微信公众号新媒体运营服务。</h2>
					<div class="content_box">
						<div class="picture_box">
							<div class="picture">
								<div class="title" style="font-size:14px">第十六届上海呼吸病专题会议-介入分会场</div>
								<img src="https://www.shshtec.com/pictures/small/business_3_1_1.png">
							</div>
							<div class="picture">
								<div class="title" style="font-size:14px">第十六届上海呼吸病专题会议-慢阻肺分会场</div>
								<img src="https://www.shshtec.com/pictures/small/business_3_1_2.png">
							</div>
							<div class="picture">
								<div class="title" style="font-size:14px">第十六届上海呼吸病专题会议-感染分会场</div>
								<img src="https://www.shshtec.com/pictures/small/business_3_1_3.png">
							</div>
							<div class="picture">
								<div class="title" style="font-size:14px">第十六届上海呼吸病专题会议-肿瘤分会场</div>
								<img src="https://www.shshtec.com/pictures/small/business_3_1_4.png">
							</div>
						</div>
					</div>
					</template>
					<!--医学会议服务-结束-->
				</div>
			</div>
		</div>
		<!--主营业务-结束-->
		
		<div class="block_box" id="section_certificate"></div>
		
		<!--荣誉资质-开始-->
		<div class="certificate_box">
			<div class="bg_wk">
				<div class="pub_div text_box">
					<h1>荣誉资质</h1>
					<h2>坚实的研发与创新根基</h2>
					<h3>驱动未来的核心资产</h3>
					<div class="picture"></div>
				</div>
			</div>
		</div>
		<!--荣誉资质-结束-->
		
		<!--联系我们-开始-->
		<div class="contact_box" id="section_contact">
			<h1>联系我们</h1>
			<div class="pub_div contact">
				<div class="picture"></div>
				<div class="text_box">
					<h3>上海视翰数码科技有限公司</h3>
					<p>联系电话：021-52581230</p>
					<p>手机：13601788207</p>
					<p>联系人：钱先生</p>
					<p>公司地址：上海市闵行区吴中路1050号B幢913-915室</p>
				</div>
			</div>
		</div>
		<!--联系我们-结束-->
		
		<!--Footer-开始-->
		<div class="footer">
			<p><a href="/pictures/certificate/icp.jpg" target="_blank">增值电信业务经营许可证：沪B2-20260917</a><span class="line">|</span><a href="/pictures/certificate/television.jpg" target="_blank">广播电视节目制作经营许可证：(沪)字第07163号</a><span class="line">|</span><a href="/pictures/certificate/medicine.jpg" target="_blank">药品、医疗器械互联网信息服务备案凭证：沪网药械信备字〔2026〕000167号</a></p>
			<p>&copy;2011-2026上海视翰数码科技有限公司 版权所有<span class="sp"></span>沪ICP备17017702号</p>
		</div>
		<!--Footer-结束-->
		
	</div>
</template>


<script>
	import {
		mixin
	} from '@/utils/mixin.js'
	export default {
		name: 'IndexPage',
		mixins: [mixin],
		components: {
		},
		data() {
			return {
				menu: null,		//菜单
				showpage: false,	//显示
				
				businessList: [
					'手术转播系统',
					'视频直播点播系统',
					'医学会议服务'
				],
				business: 0,	//主营业务，默认
				
				shijiao: 0,		//手术示教和手术转播
				shijiaoList: [
					'上海长海医院消化内镜中心',
					'上海公立医院消化内镜中心',
					'上海长海医院临床研究中心会议室',
					'国家消化内科专业医疗质量控制中心'
				],	//示教系统子类列表
				shijiaoPictureList: [],	//示教系统图片集
				
				video: 0,		//视频直播点播系统
				videoList: [
					'消化内镜',
					'呼吸内镜',
				],	//视频直播点播系统子类列表
				videoPictureList: [],	//视频直播点播系统图片集
			}
		},
		computed: {
		},
		mounted() {
		},
		beforeDestroy() {
		},
		created() {
			if(this.isMobile())
			{
				window.location.href = '/m'
			}
			else
			{
				this.showpage = true
				this.shijiaoHandle(this.shijiao)
				this.videoHandle(this.video)
			}
		},
		methods: {
			//主营业务切换
			businessHandle(index)
			{
				this.business = index
			},
			//示教系统子类切换
			shijiaoHandle(index)
			{
				this.shijiao = index
				if(this.shijiao == 0)
				{
					this.shijiaoPictureList = []
					let param1 = {
						Title: '长海医院会议室',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_1_1.png'
					}
					let param2 = {
						Title: '长海医院导播机房',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_1_2.png'
					}
					let param3 = {
						Title: '上海国际会议中心',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_1_4.png'
					}					
					this.shijiaoPictureList.push(param1)
					this.shijiaoPictureList.push(param2)
					this.shijiaoPictureList.push(param3)
					
				} else if(this.shijiao == 1)
				{
					this.shijiaoPictureList = []
					let param1 = {
						Title: '会议室',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_2_1.png'
					}
					let param2 = {
						Title: '手术室摄像头安装',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_2_2.png'
					}
					let param3 = {
						Title: 'ERCP导播设备机柜',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_2_3.png'
					}					
					this.shijiaoPictureList.push(param1)
					this.shijiaoPictureList.push(param2)
					this.shijiaoPictureList.push(param3)
					
				} else if(this.shijiao == 2)
				{
					this.shijiaoPictureList = []
					let param1 = {
						Title: '会议室',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_3_1.png'
					}
					let param2 = {
						Title: '机房',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_3_2.png'
					}
					let param3 = {
						Title: '会议室',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_3_3.png'
					}					
					this.shijiaoPictureList.push(param1)
					this.shijiaoPictureList.push(param2)
					this.shijiaoPictureList.push(param3)
					
				} else if(this.shijiao == 3)
				{
					this.shijiaoPictureList = []
					let param1 = {
						Title: '本地PPT模式',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_4_1.png'
					}
					let param2 = {
						Title: '手术转播模式',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_4_2.png'
					}
					let param3 = {
						Title: '质控中心演示模式',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_4_3.png'
					}					
					this.shijiaoPictureList.push(param1)
					this.shijiaoPictureList.push(param2)
					this.shijiaoPictureList.push(param3)
				}
			},
			//视频点播直播子类切换
			videoHandle(index)
			{
				this.video = index
				if(this.video == 0)
				{
					this.videoPictureList = []
					let param1 = {
						Title: '空中大讲堂',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_1_1.png'
					}
					let param2 = {
						Title: '空中大讲堂',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_1_2.png'
					}
					let param3 = {
						Title: '学术论坛',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_1_3.png'
					}					
					this.videoPictureList.push(param1)
					this.videoPictureList.push(param2)
					this.videoPictureList.push(param3)
					
				} else if(this.video == 1)
				{
					this.videoPictureList = []
					let param1 = {
						Title: '呼吸沙龙',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_2_1.png'
					}
					let param2 = {
						Title: '培训学院',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_2_2.png'
					}
					let param3 = {
						Title: '护理年会',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_2_3.png'
					}					
					this.videoPictureList.push(param1)
					this.videoPictureList.push(param2)
					this.videoPictureList.push(param3)
					
				}
			},
			// 导航
			menuHandle(dot)
			{
				if(this.menu != dot)
				{
					this.menu = dot
					const element = document.getElementById('section_'+dot);
					if (element) {
						element.scrollIntoView({ 
							block: 'start', 
							behavior: 'smooth' ,
						});
					}
				}
				else
				{
					this.menu = ''
					//返回顶部
					window.scrollTo({
						top: 0,
						behavior: 'smooth' // 平滑滚动
					});
				}
			},
		},
	}
</script>

<style lang="less" scoped>
	.container {
		
		.block_box {
			height: 73px;
		}
		
		.pub_div {
			width: 1300px;
			margin: 0 auto;
		}
		
		h1 {
			font-size: 30px;
			font-weight: 400;
		}
		
		/*头部*/
		.header {
			width: 100%;
			padding: 15px 0;
			box-sizing: border-box;			
			background-color: #fff;
			box-shadow: 1px 1px 3px #eee;
			position: fixed;
			top: 0;
			z-index: 2000;
			
			.hd_box {
				display: flex;
				justify-content: space-between;
				
				.logo {
					width: 406px;
					height: 43px;
					background-position: center;
					background-repeat: no-repeat;
					background-size: 100% 100%;
					background-image: url(@/assets/images/logo.png);
					
					a {
						display: block;
						height: 43px;
					}
				}
				
				.menu {
					ul {
						display: flex;
						align-items: center;
						
						li {
							margin-left: 40px;
							a  {
								height: 43px;
								line-height: 43px;
							}
						}
					}
				}
			}
		}
		
		/*企业介绍*/
		.about_box {
			background-color: #F4F7FF;
			
			.about_content {
				// height: 477px;
				box-sizing: border-box;
				background-position: right center;
				background-repeat: no-repeat;
				background-size: 544px 430px;
				background-image: url(@/assets/images/about_img_0.png);
				background-color: #f4f7ff;
				padding: 70px 0 40px 40px;
				
				.profile {
					width: 50%;
					margin-top: 40px;
					
					p {
						margin-bottom: 20px;
					}
					
					.btns {
						margin-top: 40px;
						display: flex;
						align-items: center;
						
						a {
							display: block;
							height: 40px;
							line-height: 38px;
							box-sizing: border-box;
							padding: 0 20px;
							border-radius: 5px;
							background-color: #355edc;
							color: #fff;
							border: #355edc solid 1px;
							cursor: pointer;
							box-shadow: 2px 2px 5px #ccc;
							margin-right: 20px;
							-webkit-transition: all .5s ease;
						}
						a:hover {
							background-color: #2148c2;
							border: #2148c2 solid 1px;
						}
					}
				}
			}
		}
	
		/*主营业务*/
		.business_box {
			background-color: #fff;
			padding-top: 20px;
			
			.business {
				h1 {
					text-align: center;
				}
				
				.main_tab_box {
					width: 95%;
					margin: 0 auto;
					padding-top: 30px;
					
					ul {
						display: flex;
						justify-content: center;
						border-bottom: #e4e4e4 solid 1px;
						padding-bottom: 12px;
						
						li {
							font-size: 18px;
							font-weight: 400;
							margin: 0 20px;
							color: #666;
							cursor: pointer;
						}
						li:hover {
							color: #33578b;
						}
						li.selected {
							font-weight: 500;
							color: #33578b;
						}
					}
				}
				
				.main_content_box {
					padding: 30px;
					
					h2 {
						font-size: 16px;
						text-align: center;
						font-weight: 400;
					}
					
					.content_box {
						margin-top: 40px;
						display: flex;
						justify-content: space-between;
						
						.left_menu {
							width: 260px;
							
							li {
								height: 40px;
								line-height: 40px;
								position: relative;
								overflow: hidden;
								margin-bottom: 12px;
								background-color: #F6F6F6;
								text-align: center;
								font-size: 14px;
								color: #444;
								cursor: pointer;
								border-radius: 5px;
							}
							li.selected {
								background-color: #ECF1FF;
								color: #2148c2;
							}
							li:last-child {
								margin-bottom: 0;
							}
						}
						
						.picture_box {
							height: 200px;
							display: flex;
							align-items:flex-start;
							justify-content: center;
							
							.picture {
								margin-left: 24px;
								position: relative;
								overflow: hidden;
								border-radius: 8px;
								
								img {
									width: 292px;
									height: auto;
									display: block;
									-webkit-transition: all 1.2s ease;
									border-radius: 8px;
								}
								.title {
									position: absolute;
									width: 100%;
									height: 40px;
									line-height: 40px;
									bottom: 0;
									left: 0;
									background-color: #000;
									color: #fff;
									opacity: .8;
									z-index: 1000;
									text-align: center;
									border-bottom-left-radius: 5px;
									border-bottom-right-radius: 5px;
									-webkit-transition: all 0.6s ease;
								}
							}
							.picture:hover {								
								img {
									transform: scale(1.1);
									-webkit-transform: scale(1.1);
								}
								.title {
									opacity: 0;
								}
							}
							.picture:first-child {
								margin-left: 0;
							}
						}
					}
				}
			}
		}
		
		/*荣誉资质*/
		.certificate_box {
			height: 662px;
			box-sizing: border-box;
			background-position: center;
			background-repeat: repeat-x;
			background-size: 100% 662px;
			background-image: url(@/assets/images/ryzz_bg.png);	
			
			.bg_wk {
				margin: 0 auto;
				max-width: 1400px;
				height: 662px;
				background-position: top 80px center;
				background-repeat: repeat-x;
				background-size: 100% 370px;
				background-image: url(@/assets/images/ryzz_1.png);
				
				.text_box {
					padding-top: 60px;
					height: 662px;
					box-sizing: border-box;
					text-align: center;
					position: relative;
					
					h2 {
						margin-top: 30px;
						font-size: 22px;
						color: #3E6DFF;
						font-weight: 400;
					}
					h3 {
						margin-top: 20px;
						font-size: 18px;
						font-weight: 400;
					}
					
					.picture {
						position: absolute;
						bottom: 0;
						width: 100%;
						height: 391px;
						background-position: top bottom;
						background-repeat: repeat-x;
						background-size: 100% 391px;
						background-image: url(@/assets/images/ryzz_2.png);
					}
				}
			}
		}
		
		/*联系我们*/
		.contact_box {
			padding-top: 60px;
			
			h1 {
				text-align: center;
			}
			.contact {
				padding: 60px 0;
				display: flex;
				justify-content: flex-start;
				
				.picture {
					width: 605px;
					height: 194px;
					background-position: center;
					background-repeat: no-repeat;
					background-size: 100% 100%;
					background-image: url(@/assets/images/contact_img.png);
				}
				
				.text_box {
					margin-left: 100px;
					
					h3 {
						font-size: 18px;
					}
					p {
						margin-top: 14px;
						font-size: 16px;
					}
				}
			}
		}
		
		/*底部*/
		.footer {
			padding: 20px 0;
			text-align: center;
			font-size: 13px;
			color: #444;
			background-color: #f9f9f9;
			
			p {
				padding: 0;
				margin: 0px 0;
				
				span.line {
					display: inline-block;
					vertical-align: middle;
					color: #ccc;
					margin: 0 15px;
				}
				span.sp {
					display: inline-block;
					vertical-align: middle;
					margin: 0 10px;
				}
			}
		}
	}
</style>